import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const CompareAlert1ToAdtHealthPage: React.FC = () => {
  const { getImage } = useImages();
  const heroImage = getImage('compare-alert1-adt-mobile-medical-alert-pendant-2-2.jpg');
  
  // Reason icons
  const savingsIcon = getImage('compare-alert1-savings-icon.jpg');
  const responseIcon = getImage('compare-alert1-response-icon.jpg');
  const buttonPushIcon = getImage('compare-alert1-button-push-icon.jpg');
  const monthlyPlanIcon = getImage('compare-alert1-monthly-plan-icon.jpg');
  const helpIcon = getImage('compare-alert1-help-icon.jpg');
  const valueImage = getImage('1-Price-Compare-Mobile-Medical-Alert.jpg');
  const familyImage = getImage('2-Price-Compare-Fall-Detection-Medical-Alert.jpg');

  return (
    <div className="compare-alert1-to-adt-health-page compare-alert1-to-life-alert-page">
      {/* Hero Section */}
      <section className="compare-hero-new">
        <div className="compare-hero-container">
          <div className="compare-hero-content">
            <h1>Discover Alert1: The Ideal Alternative to ADT Medical Alert Systems</h1>
            
            <p className="compare-hero-text">
              Alert1 offers more user-friendly features at a lower price than ADT. We believe staying safe should be affordable and effortless, offering easy-to-use medical alert devices for seniors with flexible pricing plans. Our devices are pre-programmed and "plug-in-and-go," requiring no technical expertise. Compare our in-home and mobile medical alert systems with ADT—you'll find Alert1 has similar or more features at a better price<sup>1</sup>.
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link to="/medical-alerts" className="btn btn-primary compare-hero-btn">
                VIEW SYSTEMS
              </Link>
            </div>
          </div>
          
          <div className="compare-hero-image">
            <div className="circular-image-wrapper">
              {heroImage ? (
                <img 
                  src={heroImage} 
                  alt="Elderly man with medical alert pendant" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                Call <strong>1-877-573-4195</strong> today and
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                see why Alert1 is the best
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                medical alert system provider for
              </p>
              <p style={{ fontSize: '1rem', color: '#333', margin: '0.5rem 0', lineHeight: '1.5' }}>
                you or your loved one.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Chart Section */}
      <section className="comparison-section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>Alert1 and ADT Medical Alert</h2>
            <h2 style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 700, margin: '0', padding: '0', lineHeight: '1.1', display: 'block' }}>Systems Comparison Chart</h2>
          </div>
          
          <p className="section-intro" style={{ maxWidth: '900px', margin: '0 auto 2rem auto', fontSize: '1.15rem', lineHeight: '1.7', color: '#333' }}>
            We recognize that choosing a device is a big decision, but we try to make it as easy as possible. Alert1 medical alarms are among the best in the industry, and we offer great value at affordable pricing. To make smart, informed decisions when shopping for button alarm pendants, buyers need to compare costs, contract terms, customer service, and device features.
          </p>
          
          <p className="section-intro" style={{ maxWidth: '900px', margin: '0 auto 2rem auto', fontSize: '1.15rem', lineHeight: '1.7', color: '#333' }}>
            What really sets Alert1 apart from the competition is that our trained agents are not only standing by 24/7/365 to get you or your loved one the fast help needed in an emergency, but unlike many other service providers, we stay on the line with our members until help arrives, so <strong><em>no one ever faces an emergency alone.</em></strong>
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>ADT</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Prices Starting At</strong>
                    <br />
                    <Link to="/pricing" style={{ fontSize: '0.9rem', color: '#0066cc', textDecoration: 'underline' }}>See Pricing</Link>
                  </td>
                  <td className="highlight-col">$19.95/mo<sup>1</sup></td>
                  <td>$29.99/mo<sup>2</sup></td>
                </tr>
                <tr>
                  <td><strong>No Long-Term Contract Required</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Nationwide Coverage</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>UL Listed</strong><br /><small>Monitoring center</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>BBB Accredited Business</strong><br /><small>A+ rating from the Better Business Bureau</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Unknown</td>
                </tr>
                <tr>
                  <td><strong>Constant Care</strong><br /><small>We stay on the phone until help arrives</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Multilingual Protection</strong><br /><small>Responders speak 190 different languages</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Same Day Shipping</strong><br /><small>For 85% or more of orders</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Unlimited Button Pushes</strong><br /><small>Never charges for pushing your button</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Thayer Certified</strong><br /><small>Safe, fair working environment</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>TMA 5 Diamond Certified Command Center</strong><br /><small>Ensures that each center meets only the highest standards</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Modern Senior Magazine<sup>*</sup></strong><br /><small>#1 Rated Medical Alert System</small></td>
                  <td className="highlight-col">✓</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 5 Reasons Section */}
      <section className="reasons-section" style={{ background: 'white' }}>
        <div className="container">
          <h2>5 Reasons Why Alert1 is the Best ADT Medical Alert System Alternative</h2>
          
          <div className="reasons-list">
            <div className="reason-item">
              <div className="reason-icon">
                {savingsIcon && (
                  <img src={savingsIcon} alt="Value" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">1.</span> Value</h4>
                <p>
                  We have systems to meet every need, lifestyle, and budget (invaluable protection at affordable pricing)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {responseIcon && (
                  <img src={responseIcon} alt="Support" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">2.</span> Support</h4>
                <p>
                  Once a member sends an alert, our emergency response team stays on the line with them until help 
                  arrives (not all companies do this)
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {buttonPushIcon && (
                  <img src={buttonPushIcon} alt="Simple" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">3.</span> Simple</h4>
                <p>
                  One button push connects you to trained operators who are ready to help 24/7/365
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {monthlyPlanIcon && (
                  <img src={monthlyPlanIcon} alt="Flexible" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">4.</span> Flexible</h4>
                <p>
                  No long-term contracts required—choose monthly or annual billing with easy cancellation
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {helpIcon && (
                  <img src={helpIcon} alt="Helpful" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">5.</span> Helpful</h4>
                <p>
                  Our customer service team is knowledgeable, friendly, and always ready to assist with questions or concerns
                </p>
              </div>
            </div>
          </div>

          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">TRY US TODAY</Link>
          </div>
        </div>
      </section>

      {/* Does ADT Match Alert1's Value Section */}
      <section className="alternative-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: '3rem', marginTop: '3rem', alignItems: 'center' }}>
            <div style={{ flex: 1 }}>
              <h2>Does ADT Match Alert1's Value?</h2>
              
              <ul style={{ listStyle: 'disc', paddingLeft: '2rem', lineHeight: '1.8', fontSize: '1.15rem', marginTop: '1.5rem' }}>
                <li>Alert1 agents stay on the line until help arrives, unlike some other companies, to assist during frightening emergencies. You will never face an emergency alone.</li>
                <li>Discreet, comfortable unisex alarm buttons can be worn as a pendant, wristband, or carried in a pocket.</li>
                <li>Alarm buttons are compatible with pacemakers and are showerproof for use while bathing.</li>
                <li>Alert1's personal alarms are easy to operate, pre-programmed, and shipped for free.</li>
                <li>Trained agents are available 24/7/365.</li>
                <li>Mobile medical alarm systems can summon instant help from anywhere across the USA.</li>
                <li>No extra fees are charged for frequent usage.</li>
                <li>Fall detection technology and GPS are available and recommended for comprehensive protection.</li>
                <li>Flexible payment plans, allowing members to pay monthly or advance payments for better rates.</li>
              </ul>
            </div>
            
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper">
                {valueImage ? (
                  <img 
                    src={valueImage} 
                    alt="Elderly couple walking outdoors" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
          
          <div className="cta-center" style={{ marginTop: '2rem' }}>
            <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
          </div>
        </div>
      </section>

      {/* Join the Alert1 Family Section */}
      <section className="alternative-section" style={{ background: 'white' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: '3rem', marginTop: '3rem', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <h2>Are You Ready to Join the Alert1 Family of Members?</h2>
              
              <p className="section-intro" style={{ marginTop: '1.5rem' }}>
                Now that you've compared Alert1 to ADT and other medical alert system providers, isn't it time to join our family of members? Order your new medical alarm service{' '}
                <Link to="/medical-alerts" style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#333' }}>here</Link>
                {' '}on our website, or call one of our New Member Specialists who will be happy to answer any questions and get you set up with your button alarm. It's time to enjoy the security, protection, and peace of mind you'll get from your new medical alert system!
              </p>
            </div>
            
            <div style={{ flexShrink: 0 }}>
              <div className="circular-image-wrapper">
                {familyImage ? (
                  <img 
                    src={familyImage} 
                    alt="Elderly woman with medical alert pendant" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footnotes Section */}
      <section className="alternative-section" style={{ background: '#f5f5f5', padding: '2rem 0' }}>
        <div className="container">
          <div className="table-footnote" style={{ marginTop: '0' }}>
            <p>Medical alert comparisons and pricing are based on standard rates, temporary promotions may apply, offers subject to change.</p>
            <p>¹Pricing of Alert1 annual service plans.</p>
            <p>²ADT website accessed on 9/1/2020. Information updated quarterly. ADT is a registered trademark of ADT LLC dba ADT Security Services.</p>
            <p>*Alert1 and Modern Senior Magazine are wholly owned by ResponseLINK, LLC.</p>
            <p>Please note that for all comparisons a lack of a check mark indicates that the competitor criteria is not listed on the competitor's official website.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompareAlert1ToAdtHealthPage;
